import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

const toSlug = (s) =>
  String(s || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\u0600-\u06FF\w-]+/g, "");

// مجموعهٔ کوچک و کنترل‌شده از آیکن‌ها
const ICON_OPTIONS = [
  { value: "book", labelKey: "icon_book", preview: "📚" },
  { value: "flask", labelKey: "icon_flask", preview: "🧪" },
  { value: "code", labelKey: "icon_code", preview: "💻" },
  { value: "language", labelKey: "icon_language", preview: "🗣️" },
  { value: "calculator", labelKey: "icon_calculator", preview: "🧮" },
  { value: "globe", labelKey: "icon_globe", preview: "🌍" },
  { value: "art", labelKey: "icon_art", preview: "🎨" },
  { value: "music", labelKey: "icon_music", preview: "🎵" },
  { value: "history", labelKey: "icon_history", preview: "🏛️" },
];

export default function CategoryFormFields({
  form,
  setForm,
  allCategories,
  parentCandidates = [], // ← prop جدید
  willBeLevel,
  canToggleHasSubscription,
  isOrgContext,
}) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language?.includes("fa");
  const parentOptions = parentCandidates;

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({
      ...f,
      [name]: type === "checkbox" ? checked : value,
      ...(name === "title" && !f.slug ? { slug: toSlug(value) } : {}),
    }));
  };

  const selectedParent = useMemo(
    () => allCategories.find((c) => c._id === form.parent),
    [allCategories, form.parent]
  );

  return (
    <div
      className={`grid grid-cols-1 md:grid-cols-2 gap-4 ${
        isRtl ? "text-right" : "text-left"
      }`}
    >
      {/* title */}
      <div className="col-span-1 md:col-span-2">
        <label className="block text-sm font-medium mb-1">
          {t("org_categories.form.title")}
        </label>
        <input
          className="w-full border rounded-lg px-3 py-2"
          name="title"
          value={form.title}
          onChange={onChange}
          placeholder={t("org_categories.form.title_ph")}
        />
      </div>

      {/* slug */}
      <div>
        <label className="block text-sm font-medium mb-1">Slug</label>
        <input
          className="w-full border rounded-lg px-3 py-2"
          name="slug"
          value={form.slug}
          onChange={onChange}
          placeholder="my-category"
        />
      </div>

      {/* icon (select) */}
      <div>
        <label className="block text-sm font-medium mb-1">
          {t("org_categories.form.icon")}
        </label>
        <select
          className="w-full border rounded-lg px-3 py-2"
          name="icon"
          value={form.icon}
          onChange={onChange}
        >
          <option value="">{t("org_categories.form.icon_select_ph")}</option>
          {ICON_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.preview} {t(`org_categories.form.${opt.labelKey}`)}
            </option>
          ))}
        </select>
        {form.icon && (
          <p className="text-xs text-gray-500 mt-1">
            {t("org_categories.form.icon_selected")} {form.icon}
          </p>
        )}
      </div>

      {/* parent */}
      <div className="col-span-1 md:col-span-2">
        <label className="block text-sm font-medium mb-1">
          {t("org_categories.form.parent")}
        </label>
        <select
          className="w-full border rounded-lg px-3 py-2"
          name="parent"
          value={form.parent}
          onChange={onChange}
        >
          <option value="">{t("org_categories.form.no_parent")}</option>
          {parentOptions.map((c) => (
            <option key={c._id} value={c._id}>
              {c.title} {c.level ? ` (L${c.level})` : ""}
            </option>
          ))}
        </select>
        <p className="text-xs text-gray-500 mt-1">
          {t("org_categories.form.will_be_level")} {willBeLevel}
        </p>
      </div>

      {/* description */}
      <div className="col-span-1 md:col-span-2">
        <label className="block text-sm font-medium mb-1">
          {t("org_categories.form.description")}
        </label>
        <textarea
          className="w-full border rounded-lg px-3 py-2"
          rows={3}
          name="description"
          value={form.description}
          onChange={onChange}
          placeholder={t("org_categories.form.description_ph")}
        />
      </div>

      {/* hasSubscription (فقط اگر سطح 3 خواهد شد) */}
      <div className="col-span-1 md:col-span-2 flex items-center gap-2">
        <input
          type="checkbox"
          id="hasSubscription"
          name="hasSubscription"
          checked={!!form.hasSubscription}
          onChange={onChange}
          disabled={!canToggleHasSubscription}
        />
        <label
          htmlFor="hasSubscription"
          className={`text-sm ${
            !canToggleHasSubscription ? "text-gray-400" : ""
          }`}
        >
          {t("org_categories.form.has_subscription")}
          {!canToggleHasSubscription && (
            <span className="ms-2 text-xs">
              ({t("org_categories.form.level3_only")})
            </span>
          )}
        </label>
      </div>
    </div>
  );
}
